import React from 'react';

import { useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TDR } from 'tdr-common';
import { RestaurantGuardOutletContext } from '../../routes/RestaurantGuard';
import styles from './ProceedWithLogo.module.scss';

type ProceedWithLogoProps = {
	logo: 'tablz' | 'tablz--gold' | 'alternate';
};

export const ProceedWithLogo = ({ logo }: ProceedWithLogoProps) => {
	const { restaurant } = useOutletContext<RestaurantGuardOutletContext>();
	const { t } = useTranslation();

	const altPlatform = restaurant.settings?.alternativePlatform?.vendor;

	const logoSrc =
    logo === 'tablz' || logo === 'tablz--gold'
    	? '../../images/poweredBy/tablz.svg'
    	: `../../images/poweredBy/${altPlatform}.svg`;

	const getLogoClassName = () => {
		const classes = [styles.Logo];

		if (logo === 'tablz') {
			classes.push(styles.LogoTablz);
		}
		else if (logo === 'tablz--gold') {
			classes.push(styles.LogoTablzGold);
		}
		else if (logo === 'alternate') {
			if (altPlatform === TDR.AlternativePlatform.Tripleseat) {
				classes.push(styles.LogoTripleseat);
			}
			else if (altPlatform === TDR.AlternativePlatform.SevenRooms) {
				classes.push(styles.LogoSevenRooms);
			}
		}

		return classes.join(' ');
	};

	return (
		<div className={styles.Container}>
			<span className={styles.Label}>{t('powered_by')}</span>
			<img
				src={logoSrc}
				alt={altPlatform}
				className={getLogoClassName()}
			/>
		</div>
	);
};
